import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite } from '@fortawesome/free-solid-svg-icons';
import './style.css';

const CookieSettingsButton = ({ visible, onClick }) => {
  const { t } = useTranslation('cookieConsent');

  if (!visible) return null;

  return (
    <button
      type="button"
      className="cookie-settings-fab"
      onClick={onClick}
      aria-label={t('banner.cookieSettings')}
      title={t('banner.cookieSettings')}
    >
      <FontAwesomeIcon icon={faCookieBite} />
    </button>
  );
};

export default CookieSettingsButton;
